import {bottom, Placement} from '@popperjs/core';
import React, {FC} from 'react';
import styled from 'styled-components';

import {alphas, greys} from '../../styles/colorStyles';
import {fontSizes, fontWeights} from '../../styles/fontStyles';
import {RepositionPopover, RepositionPopoverProps} from '../popovers/repositionPopover';

interface TooltipProps extends RepositionPopoverProps {
  isMultiline?: boolean;
  customMargin?: number;
  maxWidth?: number;
  minWidth?: number;
  placement?: Placement;
  persistent?: boolean;
  color?: string;
  borderRadius?: number;
}

/*
 * Style.
 */

interface TooltipStyleProps {
  $isMultiline?: boolean;
  $customMargin?: number;
  $maxWidth?: number;
  $minWidth?: number;
  $color?: string;
  $borderRadius?: number;
}
const StyledTooltipDiv = styled.div<TooltipStyleProps>`
  padding: 6px 8px;
  max-width: ${(p) => `${p.$maxWidth || 400}px`};
  min-width: ${(p) => `${p.$minWidth || 0}px`};

  border-radius: ${(p) => `${p.$borderRadius || 8}px`};
  background-color: ${(p) => p.$color || greys.shade90};
  box-shadow: 0 2px 4px ${alphas.black40};
  margin: ${(p) => getMarginStyles(p)};

  color: ${greys.white};
  font-size: ${fontSizes.verySmall};
  font-weight: ${fontWeights.normal};
  line-height: 16px;
`;

function getMarginStyles(props: TooltipStyleProps) {
  if (props.$customMargin) {
    return `${props.$customMargin}px`;
  }

  if (props.$isMultiline) {
    return '7px';
  }

  return 'auto';
}

/*
 * Component.
 */

export const Tooltip: FC<TooltipProps> = (props) => {
  const placement = props.placement || bottom;

  const isInteractive = Boolean(props.persistent);

  return (
    <RepositionPopover {...props} isInteractive={isInteractive} placement={placement} shouldSkipApplyMaxSize>
      <StyledTooltipDiv
        $isMultiline={props.isMultiline}
        $customMargin={props.customMargin}
        $maxWidth={props.maxWidth}
        $minWidth={props.minWidth}
        $color={props.color}
        $borderRadius={props.borderRadius}
      >
        {props.children}
      </StyledTooltipDiv>
    </RepositionPopover>
  );
};
